import { SubmissionForm, TextInputField, UseFormMethods } from "@bps/fluent-ui";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import {
  useCreateFieldDeviceSetting,
  useUpdateFieldDeviceSetting
} from "@libs/api/gateways/field/field-ops-gateway.hooks";
import { Permissions } from "@libs/permissions/permissions.enum";

import { DeviceSettingRowDto } from "./";

interface DeviceSettingsFormValues {
  value: string;
}

interface DeviceSettingsValueFieldProps {
  item: DeviceSettingRowDto;
}

export const DeviceSettingsValueField = ({
  item
}: DeviceSettingsValueFieldProps) => {
  const { data: hasWritePermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementWrite
  );

  const { mutateAsync: createSetting } = useCreateFieldDeviceSetting();
  const { mutateAsync: updateSetting } = useUpdateFieldDeviceSetting();

  const onSubmit = async (
    formValues: DeviceSettingsFormValues,
    actions: Pick<
      UseFormMethods<DeviceSettingsFormValues>,
      "reset" | "setValue"
    >
  ) => {
    const { value } = formValues;
    const request = {
      ...item,
      value
    };

    if (item.id === undefined) {
      await createSetting(request);
    } else {
      await updateSetting(request);
    }

    actions.reset(request);
  };

  return (
    <SubmissionForm<DeviceSettingsFormValues>
      initialValues={{ value: item.value ?? "" }}
      onSubmit={onSubmit}
      hideCancelButton
      styles={{
        root: { flexDirection: "row" },
        buttonsWrapper: { margin: 0 },
        buttons: { margin: 0 }
      }}
      hideButtons={!hasWritePermission}
    >
      {() => {
        return <TextInputField name="value" readOnly={!hasWritePermission} />;
      }}
    </SubmissionForm>
  );
};
